export const bookingPromotersGetters = {
  bookingPromoters: (state) => {
    return state.bookingPromoters;
  },
  contactsForPromoter: (state) => {
    return state.contactsForPromoter;
  },
  clientDisplayName: (state) => {
    return state.clientDisplayName;
  },
  bookingPromoterSelected: (state) => {
    return state.bookingPromoterSelected;
  },
  bookingPromoterDetailGridLayouts: (state) => state.bookingPromoterDetailGridLayouts,
  bookingPromoterSideWindowSelectedTab: (state) => state.bookingPromoterSideWindowSelectedTab,
  bookingPromoterSelectedOverView: (state) => state.bookingPromoterSelectedOverView,
  bookingPromoterSelectedBookings: (state) => state.bookingPromoterSelectedBookings,
  bookingPromoterSelectedAdditionalInfo: (state) => state.bookingPromoterSelectedAdditionalInfo,
  routeQueryModal: (state) => state.routeQueryModal,
  isSelectedPromoterLoading: (state) => state.isSelectedPromoterLoading,

  promoters_list_start_from: (state) => state.promoters_list_start_from,
  add_promoter_contact_list_start_from: (state) => state.add_promoter_contact_list_start_from,
  promoterDetails: (state) => state.promoterDetails || [],
}